<template>
    <template v-if="$route.meta.requiresAuth">
        <Main />
    </template>

    <div v-else>
        <AppNavbar />
        <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
                <component :is="Component" />
            </transition>
        </router-view>
    </div>
</template>

<script>
import AppTopBar from "../components/common/AppTopBar";
import AppMenu from "../components/common/AppMenu";
import AppNavbar from "../components/common/AppNavbar";
import Main from "./Main";

export default {
    name: "MainWrapper",
    components: {
        Main,
        AppNavbar,
        AppMenu,
        AppTopBar,
    },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
